export const BETS_REQUEST = 'betsRequest';
export const BETS_FAILURE = 'betsFailure';
export const BETS_SUCCESS = 'betsSuccess';

export const BET_EDIT_REQUEST = 'betEditRequest';
export const BET_EDIT_FAILURE = 'betEditFailure';
export const BET_EDIT_SUCCESS = 'betEditSuccess';

export const CREATE_BET_REQUEST = 'createBetRequest';
export const CREATE_BET_FAILURE = 'createBetFailure';
export const CREATE_BET_SUCCESS = 'createBetSuccess';
